// extracted by mini-css-extract-plugin
module.exports = {"button":"sSrVz","icon":"_1Y6Hh","wrapper":"_1qKwU","label":"_3ow3j"};